import { InjectedConnector } from "@web3-react/injected-connector";
import contractInfo from "../contracts/contract-info.json";

export const injected = new InjectedConnector({ supportedChainIds: [contractInfo.chainId] });
